// eModal.js typing
interface eModalStatic {
    /**
    * Will load a URL in iFrame inside the modal body.
    * @param {Object | String} data - this can be the URL string or the full detailed object.
    * @param {String} title - the string that will be shown in modal header.
    * @returns {Promise} Promise with modal $DOM element
    */
    iframe: (params, title?) => JQueryDeferred<object>;
}

// global accessor to eModal.js lib
declare var eModal: eModalStatic;

namespace appn.iframe {
    //var _reloadFlag = false;
    var _isHost = false;

    // Available on host page that creates the iframe
    var iframeHost = {
        reloadFlag: false,
        setModalIframeHeight: function(preventHeightCollapse?: boolean) {
            let $iframe = $('#e-modal-iframe') as JQuery<HTMLIFrameElement>;
            // Introduced 01 June 2026 for Datasets create wizard 
            // flagged to avoid breaking iframes across the site
            if (preventHeightCollapse) {
                // 1. Store the current height before making any changes
                let currentHeight = $iframe.height();
                // 2. Temporarily collapse the iframe so we can accurately measure the 
                // inner content. (Using '0px' is often safer than 'auto' for this trick).
                $iframe[0].style.height = '0px';
                // 3. Measure the true target height of the content
                let targetHeight = $iframe[0]?.contentWindow?.document.documentElement.scrollHeight ?? 0;
                // 4. Immediately restore the starting height so there is no visual jump
                $iframe[0].style.height = currentHeight + 'px';
                // 5. Animate smoothly to the newly calculated target height
                $iframe.animate({ height: targetHeight + 'px' });
            } else {
                $iframe[0].style.height = 'auto';
                if ($iframe[0].contentWindow !== null)
                    $iframe.animate({height: $iframe[0].contentWindow.document.documentElement.scrollHeight + 'px'});
            }
        },
        setModalContent: function($content) {
            var newHeader = $content.find('.modal-header');
            if (newHeader.length !== 0)
                this.setModalHeader(newHeader);

            var newTitle = $content.find('.modal-title');
            if (newTitle.length !== 0) setModalTitle(newTitle);

            var $newToolbar = $content.find('.modal-toolbar');
            if ($newToolbar.length !== 0) setModalToolbar($newToolbar);

            var newFooter = $content.find('.modal-footer');
            if (newFooter.length !== 0) setModalFooter(newFooter);

            //$content.remove();
        },
        setModalHeader: function($header) {
            var $dialog = $('#e-modal-dialog');
            var currentHeader = $dialog.find('.modal-header');
            currentHeader.replaceWith($header);
        },
        setModalTitle: function($title) {
            var $dialog = $('#e-modal-dialog');
            var currentTitle = $dialog.find('.modal-title');
            currentTitle.replaceWith($title);
        },
        setModalToolbar: function($toolbar) {
            var $dialog = $('#e-modal-dialog');
            var $currentToolbar = $dialog.find('.modal-toolbar');
            $currentToolbar.replaceWith($toolbar);
        },
        setModalFooter: function($footer) {
            var $dialog = $('#e-modal-dialog');
            var content = $dialog.find('.modal-content');
            var currentFooter = $dialog.find('.modal-footer');
            if (currentFooter.length === 0)
                content.append($footer);
            else
                currentFooter.replaceWith($footer);
        },
        startLoader: function() {
            appn.dialog.showLoading();
        },
        stopLoader: function() {
            appn.dialog.hideLoading();
        },
        closeModal: function() {
            $('#e-modal').modal('hide');
        },
        setModalSizeClass: function(sizeClass) {
            if (sizeClass === null || sizeClass === undefined || sizeClass.length === 0)
                return;

            $('#e-modal-dialog').addClass(sizeClass);
        }
    };

    export function init() {
        // Hook up iframeHost on parent windows
        if (window.parent === window) {
            _isHost = true;
            (window as any).appnHost = iframeHost;
            initHost();
        }
        else
            initClient();
    }

    function initHost() {
        $(document).on('click', '[data-modal-iframe]', function(e) {

            // Must hide any other modal here. This globally fixes the issue when there is already a modal showing.
            $('.modal').modal('hide');

            var data = $(this).data();
            e.preventDefault();
            openModal(data);
        });
    }
    
    export function getHost(): typeof iframeHost {
        var win = _isHost ? window : parent;
        return (win as any).appnHost as typeof iframeHost;
    }

    function initClient() {
        $('body').attr('id', 'appn-iframe-modal-body'); // We override the default bg by id to ensure it's removal. Content/theme/appn.less body#appn-iframe-modal-body { background-color: transparent; }

        $('body')
            .css('padding-right', '18px')
            .css('padding-left', '18px')
            .css('padding-top', '3px')
            .css('padding-bottom', '3px');

        var $modaliframeData = $('#modal-data'); // data passed from client to host if any
        if ($modaliframeData.length != 0) {
            loadModalData($modaliframeData);
        }

        getHost()?.stopLoader();

        $('select:not(.select2-skipheight)').each(function() {
            $(this).on('select2:open', function() {
                select2SetHeight();
            });
            $(this).on('select2:close', function() {
                select2SetHeight();
            });
        });

        // Date Picker
        $('.datepicker').on('dp.show dp.hide', function() {
            ui.handleParentResize(0, 15);
        });

        // Changing tabs in Notifications
        $('#notifications-tabs a.nav-link').on('shown.bs.tab', function() {
            ui.handleParentResize(0, 50);
        });

        // Dismissing Notifications
        $('#notifications-tabs button.dismiss-selected').on('click', function() {
            ui.handleParentResize(0, 0);
        });

        // Create New Recurring Task via Task Template
        // Finding street in Task Location
        $('#locatebtn').on('click', function() {
            ui.handleParentResize(290, 0);
        });

        // Adding rows to a table
        $('.addRow.btn').on('click', function() {
            ui.handleParentResize(0, 0);
        });

        // Hiding the options dropdown when expanding or collapsing a grouped .card
        $('.notification-parent').click(function(event) {
            $('#btnNotificationsOptions .dropdown-menu').dropdown('hide');
            var element = event.currentTarget;
            setTimeout(function() {
                element.scrollIntoView({
                    behavior: "auto",
                    block: "center"
                });
            }, 5);
        });

        // Ensuring that when the options dropdown is shown that there is space in the iframe to display the complete dropdown
        $('#btnNotificationsOptions .btn.btn-tool:not(.btn-refresh)').on('click', function() {
            var $iframe = parent.document.getElementById('e-modal-iframe');
            if ($iframe === null)
                return;
            var iframeHeight = $iframe.offsetHeight;
            if ($('#btnNotificationsOptions').hasClass('show') || iframeHeight > 275)
                ui.handleParentResize(0, 50);
            else
                $iframe.style.height = '275px';
        });

        // Edit Entry - Scaling for Image field after changing
        $('#updatedAttachFile').on('change', function() {
            ui.handleParentResize(10, 0);
        });

        // Scaling for Dragging a textarea out of the card
        var textAreaResize = function(selector) {
            $(selector).on('mousedown', function() {
                var resizeInt = setInterval(() => ui.handleParentResize(0, 0), 1000 / 15);
                $(window).on('mouseup', function() {
                    if (resizeInt !== null) {
                        clearInterval(resizeInt);
                        ui.handleParentResize(0, 0);
                    }
                });
            });
        };
        textAreaResize('#Answer_Value');
    }

    // Ensure we add the selected item after a search and not the first item found when filtering a dualListbox
    // https://github.com/istvan-ujjmeszaros/bootstrap-duallistbox/issues/110
    $(document).on('keyup', ".bootstrap-duallistbox-container .filter", function() {
        $(this).blur();
        $(this).focus();
    });

    function loadModalData($modaliframeData) {
        if (parent === window)
            throw new Error('Modal iframe (div#modal-data) data can only live inside the iframe content');

        var host = getHost();
        if (host === undefined)
            throw new Error('#appnEModal is not present on the Host page');

        var modalSize = $modaliframeData.data('e-modal-size');
        host.setModalSizeClass(modalSize);

        // bind events to DOM before moving to host page
        if ($modaliframeData.find('[data-submit-type]').length !== 0)
            bindSubmitButtonsAndNavLinks($modaliframeData);

        // move content to host page modal
        host.setModalContent($modaliframeData);

        // Timeout ensures the height gets set and iframe is displayed
        setTimeout(function() {
            host.setModalIframeHeight();
        }, 250);
    }

    function select2SetHeight() {
        var $parentiFrame = parent.document.getElementById('e-modal-iframe');

        setTimeout(function() {
            if ($parentiFrame === null)
                return;
            $parentiFrame.style.height = 'auto';
            $parentiFrame.style.height = document.documentElement.scrollHeight + 15 + 'px';
        }, 0);
    }

    export function openModal(options) {
        // Direct use: options = { url, size, title }
        // DataDash use: options = { modalIframe, modalSize, modalTitle }

        return eModal.iframe({
            url: options.modalIframe || options.url,
            size: options.modalSize || options.size || 'modal-lg',
            title: options.modalTitle || options.title || ' ',
            scrolling: options.iframeScrolling || options.scrolling || 'yes',
            iframeHeight: 'auto'
        }).then(function() {
            return $('#e-modal');
        });
    }

    // Specify specific classes on buttons when using Iframe :
    // data-submit-type - Required for button methods
    export function bindSubmitButtonsAndNavLinks($content) {
        var formId = $content.data('form-selector');
        formId = formId || '#appnForm';
        var $form = $(formId);

        // Find the submitType button on the form, add if there is not one
        var $submitTypeInput = $form.find('[name="submitType"]');
        if ($submitTypeInput.length === 0) {
            $submitTypeInput = $('<input type="hidden" name="submitType"></input>');
            $form.append($submitTypeInput);
        }

        // Assign the submitType methods to the navigation buttons (eg Save)
        $content.find('[data-submit-type]').click(function(this: HTMLElement, e: any) {
            e.preventDefault();

            if (!$(this).hasClass('noReload'))
                getHost().reloadFlag = true;
            
            if ($(this).data('submitType') === ('Send')) {
                $form.find('[name="submitType"]').remove();
                const submitValue = $(this).data('submitType');
                $form.append(`<input type="hidden" name="submitType" value="${submitValue}" />`);
            }
            else {
                $submitTypeInput.val($(this).data('submitType'));
            }

            if ($form.valid()) {
                $form.submit();
                // response from form submit will redirect parent or otherwise instruct modal
            }
        });

        $content.find('.modal-footer a').click(function(this: HTMLElement, e: any) {
            e.preventDefault();
            getHost()?.startLoader();
            window.location.href = $(this).attr('href') ?? '';
        });
    }

    export function startLoader() {
        getHost()?.startLoader();
    }

    export function stopLoader() {
        getHost()?.stopLoader();
    }

    export function setModalIframeHeight(preventHeightCollapse?: boolean) {
        getHost()?.setModalIframeHeight(preventHeightCollapse);
    }

    export function setModalContent($content) {
        getHost()?.setModalContent($content);
    }

    export function setModalHeader($header) {
        getHost()?.setModalHeader($header);
    }

    export function setModalTitle($title) {
        getHost()?.setModalTitle($title);
    }

    export function setModalToolbar($toolbar) {
        getHost()?.setModalToolbar($toolbar);
    }

    export function setModalFooter($footer) {
        getHost()?.setModalFooter($footer);
    }

    export function setModalSizeClass(sizeClass) {
        getHost()?.setModalSizeClass(sizeClass);
    }

    export function closeModal() {
        getHost()?.closeModal();
    }
}
